var runtime = require("../../../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"utility-input":"YHMJp","utilityInput":"YHMJp"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .YHMJp{position:absolute;top:-9000px;left:-9000px;font-family:initial}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

